import type { PropsWithChildren } from 'react'
import { Outlet } from 'react-router-dom'

import { LocationInputProvider } from 'src/shared/features/users/components/marketplace/context/use-location-input'
import MemoizedMarketplaceHeader from 'src/shared/features/users/components/marketplace/header'

const PublicLayout = ({ children, profile = false }: PropsWithChildren<{ profile?: boolean }>) => {
  return (
    <LocationInputProvider>
      <div className="flex min-h-screen w-full flex-col">
        <MemoizedMarketplaceHeader profile={profile} />
        <main className="mx-auto mt-[70px] w-full md:mt-[100px]">{children || <Outlet />}</main>
      </div>
    </LocationInputProvider>
  )
}

export default PublicLayout
